import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import {  TemaPrioritario } from '../models';


class DataTablesResponse {
    data: TemaPrioritario[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}

@Injectable({
    providedIn: "root"
})
export class TemaPrioritarioService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}TemiPrioritari/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<DataTablesResponse>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<TemaPrioritario[]>(
            `${this.apiUrl}`
        );
    }
    insert(s: TemaPrioritario) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: TemaPrioritario) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:TemaPrioritario){
        if(s.id)return this.update(s);
        return this.insert(s);
    }

}
